import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    conversation: { userCategories, addMessagesCategories, removeMessagesCategories, updateAllMessagesCategories },
  },
} = config

const getCategories = params => axios.get(userCategories, { headers: getHeaders(true), params })

const updateConversationCategory = data => axios.post(userCategories, data, { headers: getHeaders(true) })

const addConversationMessagesCategories = data => axios.post(addMessagesCategories, data, { headers: getHeaders(true) })

const removeConversationMessagesCategories = data => axios.post(removeMessagesCategories, data, { headers: getHeaders(true) })

const updateAllConversationMessagesCategories = data => axios.post(updateAllMessagesCategories, data, { headers: getHeaders(true) })

export default {
  getCategories,
  updateConversationCategory,
  addConversationMessagesCategories,
  removeConversationMessagesCategories,
  updateAllConversationMessagesCategories
}
